// Translation: Model > Access key manager > Access key managing dialog > Access key information form (German)
export default Object.freeze({
	actions: {
		limit: ''
	},
	fields: {
		expirationDate: {
			label: '',
			helper: {
				default: '',
				invalidDate: '',
				outOfRange: ''
			}
		},
		name: {
			helper: '',
			label: '',
			placeholder: ''
		},
		type: {
			helper: '',
			label: ''
		}
	}
})
